<script>
import MentionBox from '../mentions/MentionBox.vue';

export const COMMANDS = ['Q'];

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
  },
  emits: ['replace', 'hasResults'],
  data() {
    return {
      commands: COMMANDS.map(name => {
        return {
          key: name,
          label: name,
          // eslint-disable-next-line @intlify/vue-i18n/no-dynamic-keys
          description: this.$t(`CONVERSATION.REPLYBOX.COPILOT.${name}`),
        };
      }),
    };
  },
  computed: {
    items() {
      if (!this.searchKey) {
        return this.commands;
      }
      return this.commands.filter(
        command =>
          command.key.toLowerCase().includes(this.searchKey.toLowerCase()) ||
          command.description
            .toLowerCase()
            .includes(this.searchKey.toLowerCase())
      );
    },
  },
  watch: {
    items: {
      handler(newItems) {
        this.$emit('hasResults', newItems.length > 0);
      },
      immediate: true,
    },
  },
  beforeUnmount() {
    this.$emit('hasResults', false);
  },
  methods: {
    handleMentionClick(item = {}) {
      this.$emit('replace', `!${item.key}`);
    },
  },
};
</script>

<template>
  <div>
    <MentionBox
      v-if="items.length"
      :items="items"
      type="command"
      @mention-select="handleMentionClick"
    />
  </div>
</template>
